import type { Vec3 } from '../core/math'

/**
 * The only allowed path from float64 world coordinates to three.js (D-011).
 * Subtracts the camera in float64 first, so the float32 result is small and precise.
 * `out` is usually an Object3D.position.
 */
export function toRenderSpace(x: number, y: number, z: number, cam: Vec3, out: Vec3): Vec3 {
  out.x = Math.fround(x - cam.x)
  out.y = Math.fround(y - cam.y)
  out.z = Math.fround(z - cam.z)
  return out
}
